import * as Types from '../../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DisconnectCareGiverMutationVariables = Types.Exact<{
  caregiverUuid: Types.Scalars['String']['input'];
  careRecipientUuid: Types.Scalars['String']['input'];
}>;


export type DisconnectCareGiverMutation = { __typename?: 'Mutation', disconnectCareGiver: boolean };


export const DisconnectCareGiverDocument = gql`
    mutation DisconnectCareGiver($caregiverUuid: String!, $careRecipientUuid: String!) {
  disconnectCareGiver(
    careGiverUuid: $caregiverUuid
    careReceiverUuid: $careRecipientUuid
  )
}
    `;
export type DisconnectCareGiverMutationFn = Apollo.MutationFunction<DisconnectCareGiverMutation, DisconnectCareGiverMutationVariables>;

/**
 * __useDisconnectCareGiverMutation__
 *
 * To run a mutation, you first call `useDisconnectCareGiverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectCareGiverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectCareGiverMutation, { data, loading, error }] = useDisconnectCareGiverMutation({
 *   variables: {
 *      caregiverUuid: // value for 'caregiverUuid'
 *      careRecipientUuid: // value for 'careRecipientUuid'
 *   },
 * });
 */
export function useDisconnectCareGiverMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectCareGiverMutation, DisconnectCareGiverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectCareGiverMutation, DisconnectCareGiverMutationVariables>(DisconnectCareGiverDocument, options);
      }
export type DisconnectCareGiverMutationHookResult = ReturnType<typeof useDisconnectCareGiverMutation>;
export type DisconnectCareGiverMutationResult = Apollo.MutationResult<DisconnectCareGiverMutation>;
export type DisconnectCareGiverMutationOptions = Apollo.BaseMutationOptions<DisconnectCareGiverMutation, DisconnectCareGiverMutationVariables>;